$(function () {
  var gallery = $(".js-ricohgr3-gallery");

  $(window).on("load resize", function () {
    var win = $(window).width();
    win < 768 ? gallerySlickSet() : gallery.slick('unslick');
  });

  mondoSlickSet();

  function gallerySlickSet() {
    gallery.not('.slick-initialized').slick({
      dots: false,
      speed: 400,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "10%",
      prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
      nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
    });
  }

  // 関連コンテンツ　slickスライダーのセッティング
  function mondoSlickSet() {
    $('.js-ricohgr3-slick').on('init', function () {
      $('.slick-dots li:first-child svg').addClass('is-active');
      $('.slick-current').addClass('is-active');
    }).on('beforeChange', function () {
      $('.slick-active svg').removeClass('is-active');
      $('.slick-current').removeClass('is-active');
    }).on('afterChange', function () {
      $('.slick-active svg').addClass('is-active');
      $('.slick-current').addClass('is-active');
    });

    $('.js-ricohgr3-slick').not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [{
        breakpoint: 768,
        settings: {
          dots: true,
          autoplay: true,
          autoplaySpeed: 7000,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }],
      customPaging: function (slider, i) {
        return $('<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><g><circle cx="7" cy="7" r="7" stroke="none"/><circle cx="7" cy="7" r="6"/></g></svg>');
      },
      prevArrow: '<div class="u-slide-arrow u-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 29"><defs><clipPath id="a"><path transform="translate(-.142 -.142)" d="M0 0h16v29H0z"/></clipPath></defs><g data-name="マスクグループ 161" transform="rotate(180 7.929 14.429)" clip-path="url(#a)" opacity=".5"><path d="M14.885 26.787l-.994.994L0 13.89 13.89 0l.995.994L1.99 13.891l12.896 12.895z"/></g></svg></div>',
      nextArrow: '<div class="u-slide-arrow u-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 29"><defs><clipPath id="a"><path transform="translate(-.142 -.142)" d="M0 0h16v29H0z"/></clipPath></defs><g data-name="マスクグループ 161" transform="rotate(180 7.929 14.429)" clip-path="url(#a)" opacity=".5"><path d="M14.885 26.787l-.994.994L0 13.89 13.89 0l.995.994L1.99 13.891l12.896 12.895z"/></g></svg></div>'
    }).on('touchmove', function (event, slick, currentSlide, nextSlide) {
      $('.js-ricohgr3-slick').slick('slickPlay');
    });
  }

});